import { IonAvatar, IonButton, IonCard, IonCardContent, IonCol, IonImg, IonLabel, IonRow, IonText } from "@ionic/react"
import { isWebView } from "../../library/Funcs";
import Image from "../image/Image";

import './ProductItem.css';

interface Props {
    id: number,
    image: string,
    title: string,
    price: string,
    oldPrice: string,
    progress: number,
    link: string
}

const ProductItem: React.FC<Props> = (props) => {
    return <IonCard routerLink={props.link} button className="product-item">
        <Image src={props.image} />

        <div className="text-section">
            <IonText className="title">{props.title}</IonText>

            <div className="price-container">
                {isWebView() ? <IonLabel class="old-price"><s>{props.oldPrice}</s></IonLabel> : null} <IonLabel class="price">{props.price}</IonLabel>
            </div>

            <IonButton size="small" color="primary">
                <IonText>توضیحات</IonText>
            </IonButton>
        </div>
    </IonCard>
}

export default ProductItem